import { Button } from '@mui/material';
import "./StandardBtn.scss";

/* eslint-disable */
import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get_lang } from '../../../../global-functions/apiGlobal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { withTranslation, useTranslation } from "react-i18next";
import { parseNumber } from "../../../../global-functions/roundFixed";

function StandardBtn(props) {
  const appState = useSelector((state) => state);
  const { t } = useTranslation();
  let history = useHistory()
  const {type='text-btn', handleCheckout, label = '', disabled = false, requiredClass = 'payBtn', bntStyle = 'border-none'} = props;
  return (

    <section id="standard-btn" className='w-100'>
 
      <Button
        variant="contained"
        className={`col-12 px-4   text-capitalize d-flex justify-content-between align-items-center ${requiredClass} ${bntStyle}`}
        onClick={handleCheckout}
        disabled={disabled}
      >

        {type=='checkout-btn' && 
        <span className="mx-2 d-flex align-items-center justify-content-between w-100">
         <strong>{label}</strong>

        <div className="iconsParent d-flex justify-content-center">
                {appState.acceptedPayments.map((item, index) => {
                  return (
                    <span key={index}>
                      {item === "knet" ? (
                        <span className=" iconsBg ">
                          <img className="img-pr" src={`/images/pat-knet.svg`} alt="" />
                        </span>
                      ) : ( "" )}

                      {item === "card" ? (
                        <span className="iconsBg">
                          <img className="img-pr" src={`/images/visa-small.svg`} alt="" />
                        </span>
                      ) : ( "" )}
                      
                      {item == "apple_pay" ? (
                        <span key={index} className="iconsBg">
                          <img className="img-pr" width="50" src={`/images/pat-apple-n.svg`} alt="" />
                        </span>
                      ) : ( "" )}
                      
                    </span>
                  );
                })}
        </div>
        </span>}

        {type == 'review-order' && 
           <span className="mx-2 d-flex align-items-center justify-content-between w-100   ">
           <strong>{label}</strong>

               <span>
                 <span style={{ padding: "0 10px" }}>
                   {t("product.Total")}
                 </span>
                 <b>{parseNumber((appState.total), appState.storeInfo.numberFixed)}</b>
                 <span>
                   {" "}
                   &nbsp;
                   {get_lang(
                     appState.storeInfo.storeCurrency,
                     appState.langValue
                   )}
                 </span>
               </span>
               </span>
        }

        {type == 'view-cart' && 
              <span className="mx-2 d-flex align-items-center justify-content-between w-100   ">
                <div className="itemCounter3">
                            <span className="itemCounterText"> 
                              {appState.cart.length}
                            </span>
                            <span className=" mx-2">
                              {t("View Cart")}
                            </span>
                          </div>

                <div className="priceTagDynamic"> {appState.total != null && parseNumber((appState.total), appState.storeInfo.numberFixed)}
                <span> &nbsp; {get_lang ( appState.storeInfo.storeCurrency, appState.langValue )} </span>
              </div>
              </span>
        }

        {type=="text-btn" && 
          <span className="mx-2  w-100   ">
            <strong>{label}</strong>
          </span>
        }
       
       

      </Button>
    </section>
  )
}

  export default withTranslation()(StandardBtn)